<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Wymogi IDD'" [name]="'Lista'"></app-breadcrumb>
<div class="idd-training-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">
    <mat-form-field class="idd-training-list-filter">
      <mat-label>Rok</mat-label>
      <input type="number" matInput placeholder="2021" name="year" [(ngModel)]="initialFilters.year">
    </mat-form-field>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="idd-training-list-filter idd-training-list-filter-long"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-dict-partners
      [multiple]="false" label="Partner"
      class="idd-training-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-regionals
      [multiple]="false" label="Regionalny (majątek) Partnera"
      class="idd-training-list-filter idd-training-list-filter-long"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <app-dict-regionals
      [multiple]="false" label="Regionalny (majątek) OFWCA"
      class="idd-training-list-filter idd-training-list-filter-long"
      [(ngModel)]="initialFilters.ofwcaAssetsRegional" name="ofwcaAssetsRegional"
    ></app-dict-regionals>

    <app-dict
      [multiple]="true" [dictType]="'idd_training_status'"
      [label]="'Status'" class="idd-training-list-filter"
      [(ngModel)]="initialFilters.in$status" name="in$status"
    ></app-dict>

    <mat-form-field class="idd-training-list-filter">
      <mat-label>Numery RAU</mat-label>
      <input matInput placeholder="Wymień po przecinku" name="rauNumber" [(ngModel)]="initialFilters.rauNumber">
    </mat-form-field>

    <mat-form-field appearance="standard" class="idd-training-list-filter">
      <mat-label>Tematyka Szkoleń</mat-label>
      <mat-select
        [multiple]="true"
        [(ngModel)]="initialFilters.subjecTraining" name="subjecTraining"
      >
        <mat-option [value]="0">Majątek</mat-option>
        <mat-option [value]="1">Życie</mat-option>
        <mat-option [value]="2">Ogólne</mat-option>
      </mat-select>
    </mat-form-field>

    <app-dict-partners
      [multiple]="false" label="Partner nadrzędny"
      class="idd-training-list-filter"
      [(ngModel)]="initialFilters.parentPartner" name="parentPartner"
    ></app-dict-partners>

    <mat-form-field
      appearance="standard"
      class="idd-training-list-filter">
      <mat-label> IDD konkursy OFWCA</mat-label>
      <mat-select [(ngModel)]="initialFilters.competitionRequirementsMet" name="competitionRequirementsMet">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Aktywny</mat-option>
        <mat-option [value]="0">Nieaktywny</mat-option>
      </mat-select>
      </mat-form-field>
  </form>

  <div fxLayout="row" fxLayoutGap="15px">
    <div>
      <app-detail style="position: relative; top: -13px" header="Dni do końca roku" [value]="daysToEndOfYear.toString()"></app-detail>
    </div>
    <span fxFlex></span>
    <div>
      <button (click)="generateCertificates()" [disabled]="!(userPermissions | async).idd_training.read_report"
              mat-raised-button color="accent"><mat-icon>download</mat-icon> <span> Pobierz zaświadczenia</span></button>
    </div>
    <div>
      <button *ngIf="(userPermissions | async)?.idd_training_additional.read_report" (click)="downloadReportRegional()" [disabled]="!(userPermissions | async)?.idd_training_additional.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    </div>
    <div>
      <button *ngIf="(userPermissions | async).idd_training.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).idd_training.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    </div>
    <div>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    </div>
    <div>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="iddTrainings">

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/szkolenia-idd/szczegoly', element.uuid]">IDD {{element.year}} {{element.ofwca.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca.uuid]">{{element.ofwca.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="rau">
      <th mat-header-cell *matHeaderCellDef> RAU </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngFor="let rau of element.ofwca.rauNumbers">
          {{rau.rau}} <br>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.ofwca?.partner" class="default-link" [routerLink]="['/partnerzy/szczegoly', element.ofwca?.partner?.uuid]">{{element.ofwca?.partner?.shortName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwcaAssetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) OFWCA </th>
      <td mat-cell *matCellDef="let element">
        {{element.ofwca.assetsRegional?.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="partnerAssetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) Partnera</th>
      <td mat-cell *matCellDef="let element">
        {{element.ofwca?.partner?.assetsRegionalFullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status?.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="chart">
      <th mat-header-cell *matHeaderCellDef> Postęp </th>
      <td mat-cell *matCellDef="let element">
        <app-idd-training-chart [iddTraining]="element" [chartType]="chartType" style="height: 30px; width: 250px; display: block"></app-idd-training-chart>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element">
        <button (click)="addCertificate(element)"
                [disabled]="!(userPermissions | async).idd_training.write"
                mat-icon-button color="primary"><mat-icon>add</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
